import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface Workspace {
  id: string;
  name: string;
  description?: string;
  tooltip?: string;
  url: string;
  icon?: string; // SVG content or icon identifier
}

@Component({
  selector: 'app-workspace-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './workspace-card.component.html',
  styleUrls: ['./workspace-card.component.scss']
})
export class WorkspaceCardComponent {
  @Input() workspace!: Workspace;
  @Output() workspaceClick = new EventEmitter<Workspace>();

  showTooltip = false;

  // Cache the sanitized icon to prevent infinite change detection loops
  private _cachedIcon: string | undefined;
  private _cachedSafeIcon: SafeHtml | null = null;

  constructor(private sanitizer: DomSanitizer) { }

  get safeIcon(): SafeHtml | null {
    // Only recreate SafeHtml if the icon has changed
    if (this.workspace.icon !== this._cachedIcon) {
      this._cachedIcon = this.workspace.icon;
      this._cachedSafeIcon = this.workspace.icon
        ? this.sanitizer.bypassSecurityTrustHtml(this.workspace.icon)
        : null;
    }
    return this._cachedSafeIcon;
  }

  onClick(): void {
    this.workspaceClick.emit(this.workspace);
  }

  onInfoClick(event: Event): void {
    event.stopPropagation();
  }

  onMouseEnter(): void {
    this.showTooltip = true;
  }

  onMouseLeave(): void {
    this.showTooltip = false;
  }
}
